import { render, staticRenderFns } from "./ChangelogTableRow.vue?vue&type=template&id=985f2d20&"
import script from "./ChangelogTableRow.vue?vue&type=script&lang=js&"
export * from "./ChangelogTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports